<template>
    <Link
        :href="route('bridge.index')"
        class="inline-flex items-center gap-1 text-sm font-medium text-rent-risk-blue-400 hover:underline"
    >
        <font-awesome-icon :icon="faChevronLeft" class="h-3 w-3" />
        Back to the Bridge
    </Link>
</template>

<script setup>
import { Link } from '@inertiajs/vue3'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons'
</script>
